module.exports = __webpack_public_path__ + "img/inform-icon.18a67bc2.svg";